<router-outlet></router-outlet>
<vex-network-warning></vex-network-warning>
